import { Nullable } from "common/types";
import { Record, fromJS, Map } from "immutable";

export const taskContextFromJSON = (json: ITaskContextData): TaskContextRecord => {
  const data: Partial<ITaskContextRecord> = { ...(json as any) };

  if (json.action_payload) {
    data.action_payload = fromJS(json.action_payload);
  }

  return new TaskContextRecord(data);
};

export interface ITaskContextData {
  model: string;
  action?: string;
  action_payload?: any;
  error_action?: string;
}

export interface TaskContextOverrides {
  action?: string;
  error_action?: string;
  action_payload?: Record<string, unknown>;
}

export interface ITaskContextRecord {
  model: string;
  action: string;
  action_payload: Nullable<Map<string, any>>;
  error_action: string;
}

const defaultTaskContextProps = {
  model: "",
  action: "taskHandler",
  action_payload: null,
  error_action: "",
};

export class TaskContextRecord
  extends Record<ITaskContextRecord>(defaultTaskContextProps)
  implements ITaskContextRecord {}
